import { GhgService } from './../../../../../../../../services/ghg/ghg.service';
import { observable } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { GhgVerificationRequestModel, PaintType } from "../../../../../../../../models/ghgs/ghg.models";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";
import { useView } from "aurelia-framework";
import { EventAggregator } from 'aurelia-event-aggregator';
import { Messages } from "../../../../../../../../configuration/event-messages.constants";

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-vessel-details/environmental-verification-vessel-details.html')
export class EnvironmentalVerificationVesselDetails extends BaseEnvironmentalVerificationTab {

    public paintTypes: PaintType[];

    public numberOfEngines: { value: number }[] = [
        { value: null },
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 }
    ];
    public numberOfAuxEngines: { value: number }[] = [
        { value: null },
        { value: 0 },
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 }
    ];
    public steamTurbineBoilerSfcUnits: { key: string, name: string }[] = [
        { key: '1', name: 'g/kWh' },
        { key: '2', name: 'g/h' }
    ];
    
    public evdiFiles: File[] = [];
    public capacityPlanFiles: File[] = [];
    public currentClassCertificateFiles: File[] = [];
    public mainEngineShopTestFiles: File[] = [];
    public auxiliaryEngineShopTestFiles: File[] = [];
    public seaTrialReportFiles: File[] = [];
    public certifiedDocumentsFiles: File[] = [];
    public reliquefactionDocumentationsFiles: File[] = [];

    @observable()
    public selectedSteamTurbineBoilerSfcUnit: { key: string, name: string };

    constructor(private ghgService: GhgService, private eventAggregator: EventAggregator) {
        super();
    }

    activate(model: GhgVerificationRequestModel): void {
        super.activate(model);

        this.evdiFiles = model.evdiFiles;
        this.capacityPlanFiles = model.capacityPlanFiles;
        this.currentClassCertificateFiles = model.currentClassCertificateFiles;
        this.mainEngineShopTestFiles = model.mainEngineShopTestFiles;
        this.auxiliaryEngineShopTestFiles = model.auxiliaryEngineShopTestFiles;
        this.seaTrialReportFiles = model.seaTrialReportFiles;
        this.certifiedDocumentsFiles = model.certifiedDocumentsFiles;
        this.reliquefactionDocumentationsFiles = model.reliquefactionDocumentationsFiles;
    }

    async attached() {
        const response = await this.ghgService.getPaintTypes();
        this.paintTypes = response.paintTypes;
    }

    onYesChecked(propName) {
        this.ghgVerification[propName] = true;
    }

    onNoChecked(propName) {
        this.ghgVerification[propName] = false;
    }

    onNAChecked(propName) {
        this.ghgVerification[propName] = null;
    }

    selectedSteamTurbineBoilerSfcUnitChanged() {
        if (this.isSteamTurbine && this.selectedSteamTurbineBoilerSfcUnit.key == "1") {
            this.ghgVerification.mainSfc = this.ghgVerification.steamTurbineBoilerSfc;
            this.ghgVerification.steamTurbineBoilerSfc = null;
        } else {
            this.ghgVerification.steamTurbineBoilerSfc = this.ghgVerification.mainSfc;
            this.ghgVerification.mainSfc = null;
        }
    }

    hasOriginalSpeedPowerCurveUpdatedChanged() {
        this.eventAggregator.publish(Messages.hasOriginalSpeedPowerCurveUpdatedChanged, this.ghgVerification.hasOriginalSpeedPowerCurveUpdated);
    }
}
